import React from 'react';
import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const images = [
    require('./../../images/gallery/pic1.jpg'),
    require('./../../images/gallery/pic8.jpg'),
    require('./../../images/gallery/pic9.jpg')
]

var bnr1 = require('./../../images/background/bg-6.png');

class About extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };
    render() {
        const options = {
            loop: true,
            autoplay: true,
            margin: 30,
            nav: false,
            dots: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: {
                    items: 1
                },
                991: {
                    items: 1
                }
            }
        };
        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b30 bg-dark bg-repeat square_shape2 bg-moving" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-center">
                                <div className="mt-separator" >
                                    <h2 className="text-white text-uppercase sep-line-one " style={{ fontFamily: 'Cairo, sans-serif', fontSize: '40px', fontWeight: 'bold' }}>
                                        <span className="font-weight-300 text-primary" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '40px', fontWeight: 'bold' }} >مــــن </span >نحـــــــن</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        <div className="section-content">
                            <div className="row">
                                <div className="col-md-9 col-sm-12">
                                    <OwlCarousel className="owl-carousel about-home owl-btn-vertical-center" {...options}>
                                        {images.map((item, index) => (
                                            <div className="item" key={index}>
                                                <div className="mt-img-effect zoom-slow">
                                                    <NavLink to="/about"><img src={item} alt="" /></NavLink>
                                                </div>
                                            </div>

                                        ))}

                                    </OwlCarousel>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="about-home-right bg-white p-a30" dir='RTL'>
                                        <h3 className="m-t0"><span className="font-weight-100" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'bold' }}>بناء الأسس للمقاولات تأسست في عام  2008 م </span> </h3>
                                        <p style={{ fontFamily: 'Cairo, sans-serif', fontSize: '18px', fontWeight: 'Light' }} ><strong>مقرها الرئيسي في الأحساء

                                            .تقدم المؤسسة العديد من خدمات التشييد و البناء لجميع المشاريع السكنية والتجارية والحكومية
                                            .تهتم بناء الأسس للمقاولات كذلك بتقديم خدمات المقاولات العامة بكل احترافية و مصداقية مع جميع عملائها و موظفيها و أصحاب المصلحة
                                            .كما تلتزم بناء الأسس للمقاولات بإتقان جميع الأعمال التي تقوم بها من خلال الالتزام بتطبيق أعلى المعايير العالمية لتقديم خدمة ذات جودة عالية</strong></p>

                                        <div className="text-right">
                                            <NavLink to="/about" className="site-button-link" data-hover="Read More" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '20px', fontWeight: 'light' }}>المزيد <i className="fa fa-angle-right arrow-animation" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  
                </div>
            </>
        );
    }
};

export default About;